import { configurationApi } from '../configurationApi';
import { ServiceType } from '../types/serviceType';

interface UploadResponse {
  successful: number;
  failed: number;
  errors: string[];
  isSuccess: boolean;
  errorMessage: string;
}

const serviceEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    getServices: builder.query<ServiceType[], { centerId: string }>({
      query: ({ centerId }) => `/services?centerId=${encodeURIComponent(centerId)}`,
      providesTags: ['Services'],
    }),

    upsertService: builder.mutation<ServiceType, ServiceType>({
      query: (service) => ({
        url: '/service',
        method: 'POST',
        body: service,
      }),
      invalidatesTags: ['Services'],
    }),

    uploadServices: builder.mutation<
      UploadResponse,
      { company: string; centerId: string; file: File }
    >({
      query: ({ company, centerId, file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `Company/${company}/Center/${centerId}/Services/Upload`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Services'],
    }),

    downloadServices: builder.mutation<Blob, { company: string; centerId: string }>({
      query: ({ company, centerId }) => ({
        url: `Company/${company}/Center/${centerId}/Services/Download`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetServicesQuery,
  useUpsertServiceMutation,
  useUploadServicesMutation,
  useDownloadServicesMutation,
} = serviceEndpoints;
